module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico_outlink-426773cb5200612094e1c354c14cad23.svg";